const routers = [
    {
        path: "/",
        component: () => import("@/views/Index/index.vue")
    }
];

export default routers;
